module.exports = __webpack_public_path__ + "img/lightswitch.f38beb59.png";